import gql from 'graphql-tag'
import { QueryResult } from 'react-apollo'

export type Channel = {
  id: string
  parent: string
  name: string
  abstract: string
  description: string
  owner: string
  icon: string
  createdAt: string
  shared: boolean
  owners: string[]
  channelIcon?: string
  sourceOrgId?: string
  canExternalTasksBeAssignedToChannel?: boolean
}

export type ListChannels = QueryResult<{
  channels: Channel[]
}>

export const LIST_ORG_CHANNELS_QUERY = gql`
  query listChannels($orgId: String!) {
    channels(id: $orgId) @rest(type: "[ChannelList]", path: "/listOrgChannels?orgId=:id", endpoint: "query") {
      parent
      id
      name
      abstract
      description
      icon
      createdAt
      shared
      sharedWith
      channelIcon
      status
      sourceOrgId
      canExternalTasksBeAssignedToChannel
    }
  }
`
